import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: 0,
    height: "75vh",
    overflowX: "hidden",
    color: "var(--color-text-primary)",
  },
  formCard: {
    padding: theme.spacing(0.5, 2, 0),
    borderRadius: "calc(16px * var(--app-radius-scale, 1))",
    border: "none",
    backgroundColor: "var(--color-background-paper)",
    boxShadow: "none",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
    overflow: "hidden",
    width: "100%",
  },
  stepperWrap: {
    padding: 0,
    overflowX: "hidden",
    "& .MuiStepper-root": {
      padding: theme.spacing(1.5, 0),
      backgroundColor: "transparent",
    },
    "& .MuiStepIcon-root": {
      color: "var(--total_row_boldbackground)",
      fontSize: "1.75rem",
      transition: "all 0.3s ease",
    },
    "& .MuiStepIcon-root.MuiStepIcon-active": {
      color: "var(--color-primary-text)",
      filter: "drop-shadow(0 2px 4px rgba(51, 122, 183, 0.35))",
    },
    "& .MuiStepIcon-root.MuiStepIcon-completed": {
      color: "var(--color-primary-text)",
    },
    "& .MuiStepLabel-label": {
      fontSize: "0.75rem",
      fontWeight: 500,
      color: "var(--color-text-secondary)",
      marginTop: 6,
      transition: "color 0.2s ease",
    },
    "& .MuiStepLabel-label.MuiStepLabel-active, & .MuiStepLabel-label.MuiStepLabel-completed":
      {
        color: "var(--color-text-primary) !important",
        fontWeight: "600 !important",
        opacity: "1 !important",
      },
    "& .MuiStepLabel-label.MuiStepLabel-disabled": {
      color: "var(--color-text-secondary)",
    },
    "& .MuiStepConnector-line": {
      borderColor: "var(--total_row_boldbackground)",
      borderTopWidth: 2,
    },
    "& .MuiStepConnector-active .MuiStepConnector-line": {
      borderColor: "var(--color-primary-main)",
    },
    "& .MuiStepConnector-completed .MuiStepConnector-line": {
      borderColor: "var(--color-primary-main)",
    },
  },
  stepLabel: {
    color: "var(--color-text-secondary)",
    "&$stepLabelActive": {
      color: "var(--color-text-primary) !important",
      fontWeight: "600 !important",
      opacity: "1 !important",
    },
    "&$stepLabelCompleted": {
      color: "var(--color-text-primary) !important",
      fontWeight: "600 !important",
      opacity: "1 !important",
    },
  },
  stepLabelActive: {},
  stepLabelCompleted: {},
  stepTitle: {
    marginBottom: theme.spacing(1.5),
    fontSize: "1rem",
    fontWeight: 700,
    color: "var(--color-text-primary)",
  },
  draftBanner: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: theme.spacing(2),
    padding: theme.spacing(1.5, 2),
    marginBottom: theme.spacing(2),
    borderRadius: "calc(12px * var(--app-radius-scale, 1))",
    border: "1px solid var(--total_row_boldbackground)",
    backgroundColor: "var(--total_row_background)",
    transition: "all 0.2s ease",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "stretch",
      gap: theme.spacing(1.25),
      padding: theme.spacing(1.5),
    },
  },
  draftBannerContent: {
    minWidth: 0,
    flex: 1,
  },
  draftBannerTitle: {
    fontSize: "0.8125rem",
    fontWeight: 700,
    marginBottom: theme.spacing(0.25),
    color: "var(--color-text-primary)",
  },
  draftBannerText: {
    fontSize: "0.75rem",
    color: "var(--color-text-secondary)",
  },
  draftBannerActions: {
    display: "flex",
    gap: theme.spacing(1),
    alignItems: "center",
    flexWrap: "wrap",
    justifyContent: "flex-end",
    [theme.breakpoints.down("xs")]: {
      justifyContent: "stretch",
      "& > *": {
        flex: 1,
      },
    },
  },
  actions: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(1.5, 0),
    backgroundColor: "var(--color-background-paper)",
    borderTop: "1px solid var(--total_row_boldbackground)",
    marginTop: "auto",
    flexShrink: 0,
    minHeight: 52,
    gap: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      flexWrap: "wrap",
      padding: theme.spacing(1.25, 0),
    },
  },
  actionButton: {
    minWidth: "140px",
    [theme.breakpoints.down("xs")]: {
      minWidth: 0,
      flex: 1,
    },
  },
  actionGroup: {
    display: "flex",
    gap: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      flex: "1 1 100%",
      flexWrap: "wrap",
      "& > *": {
        flex: "1 1 auto",
      },
    },
  },
  fieldsContainer: {
    overflowY: "auto",
    overflowX: "hidden",
    minHeight: 0,
    flex: 1,
    paddingBottom: theme.spacing(1),
    paddingRight: theme.spacing(0.5),
    "&::-webkit-scrollbar": {
      width: 5,
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "var(--total_row_boldbackground)",
      borderRadius: "calc(10px * var(--app-radius-scale, 1))",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "var(--color-text-secondary)",
    },
  },
  loaderWrap: {
    minHeight: 240,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1.5),
  },
  loaderText: {
    fontSize: "0.8125rem",
    color: "var(--color-text-secondary)",
    fontWeight: 500,
  },
  accordion: {
    boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    borderRadius: "calc(8px * var(--app-radius-scale, 1)) !important",
    marginBottom: theme.spacing(1),
    border: "1px solid var(--total_row_boldbackground)",
    backgroundColor: "var(--color-background-paper)",
    color: "var(--color-text-primary)",
    "&:before": {
      display: "none",
    },
    "&.Mui-expanded": {
      margin: `0 0 ${theme.spacing(1)}px 0`,
    },
  },
  accordionSummary: {
    padding: theme.spacing(0, 1.5),
    height: "60px !important",
    minHeight: "60px !important",
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(0, 1),
    },
    "&.Mui-expanded": {
      borderBottom: "1px solid var(--total_row_boldbackground)",
      height: "60px !important",
      minHeight: "60px !important",
    },
    "& .MuiAccordionSummary-content": {
      margin: "6px 0 !important",
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(1.5),
      minWidth: 0,
      [theme.breakpoints.down("xs")]: {
        gap: theme.spacing(1),
      },
    },
    "& .MuiAccordionSummary-content.Mui-expanded": {
      margin: "6px 0 !important",
    },
    "& .MuiAccordionSummary-expandIcon": {
      color: "var(--color-text-secondary)",
      'html[data-mode="dark"] &': {
        color: "var(--color-text-primary) !important",
      },
    },
  },
  sectionBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    fontSize: "0.7rem",
    fontWeight: 700,
    lineHeight: 1,
    padding: theme.spacing(0.5, 1),
    borderRadius: 999,
    whiteSpace: "nowrap",
    marginLeft: "auto",
    flexShrink: 0,
  },
  summaryIconBox: {
    display: "flex",
    alignItems: "center",
    color: "var(--color-primary-text)",
    backgroundColor: "var(--total_row_background)",
    padding: 6,
    borderRadius: "calc(6px * var(--app-radius-scale, 1))",
    marginRight: 12,
    flexShrink: 0,
    "& svg": {
      fontSize: "1.2rem",
    },
    [theme.breakpoints.down("xs")]: {
      padding: 5,
      marginRight: 8,
      "& svg": {
        fontSize: "1.05rem",
      },
    },
  },
  summaryTextWrap: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
  },
  summaryTitle: {
    fontSize: "0.95rem",
    fontWeight: 700,
    color: "var(--color-text-primary)",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.85rem",
    },
  },
  summarySubtitle: {
    fontSize: "0.72rem",
    color: "var(--color-text-secondary)",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  accordionDetails: {
    padding: theme.spacing(1.5),
    backgroundColor: "var(--color-background-paper)",
    borderBottomLeftRadius: "calc(8px * var(--app-radius-scale, 1))",
    borderBottomRightRadius: "calc(8px * var(--app-radius-scale, 1))",
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(1.25, 1),
    },
  },
  accordionContent: {
    width: "100%",
  },
  subSectionWrap: {
    marginBottom: theme.spacing(1.5),
    "&:last-child": {
      marginBottom: 0,
    },
  },
  subSectionTitle: {
    fontSize: "0.75rem",
    fontWeight: 700,
    marginBottom: theme.spacing(1),
    color: "var(--color-primary-text)",
    textTransform: "uppercase",
    letterSpacing: "0.06em",
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    "&::before": {
      content: '""',
      display: "inline-block",
      width: 3,
      height: 14,
      backgroundColor: "var(--color-primary-main)",
      borderRadius: "calc(2px * var(--app-radius-scale, 1))",
    },
  },
  chipSelectWrap: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.spacing(0.75),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
  },
  chipSelectLabel: {
    fontSize: "0.75rem",
    fontWeight: 400,
    lineHeight: 1,
    color: "var(--color-text-secondary)",
  },
  chipSelectRequired: {
    color: "var(--error-color)",
  },
  chipSelectOptions: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(0.75),
    width: "100%",
  },
  selectChip: {
    borderRadius: "999px !important",
    border: "1px solid var(--total_row_boldbackground) !important",
    backgroundColor: "var(--color-background-paper) !important",
    color: "var(--color-text-secondary) !important",
    fontWeight: 600,
    fontSize: "0.75rem !important",
    height: "28px !important",
    transition: "all 0.18s ease",
    "&:hover": {
      borderColor: "var(--color-primary-main) !important",
      backgroundColor: "var(--total_row_background) !important",
      color: "var(--color-primary-text) !important",
    },
    "&:focus": {
      backgroundColor: "var(--color-background-paper) !important",
    },
  },
  selectChipActive: {
    borderColor: "var(--color-primary-main) !important",
    backgroundColor: "var(--color-primary-main) !important",
    color: "var(--color-primary-contrast) !important",
    "&:hover": {
      borderColor: "var(--color-primary-main) !important",
      backgroundColor: "var(--color-primary-main) !important",
      color: "var(--color-primary-contrast) !important",
    },
    "&:focus": {
      backgroundColor: "var(--color-primary-main) !important",
    },
  },
  chipSelectHelper: {
    width: "100%",
    fontSize: "0.75rem",
    color: "var(--color-text-secondary)",
  },
  successContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    padding: theme.spacing(4),
    textAlign: "center",
  },
  successIcon: {
    fontSize: "5rem",
    color: "var(--color-primary-text)",
    marginBottom: theme.spacing(2),
  },
  successTitle: {
    fontSize: "1.5rem",
    fontWeight: 600,
    color: "var(--color-text-primary)",
    marginBottom: theme.spacing(1),
  },
  successMessage: {
    fontSize: "1rem",
    color: "var(--color-text-secondary)",
    marginBottom: theme.spacing(3),
  },
  recordInfo: {
    padding: theme.spacing(2),
    backgroundColor: "var(--total_row_background)",
    borderRadius: "calc(12px * var(--app-radius-scale, 1))",
    marginBottom: theme.spacing(3),
    minWidth: 300,
    border: "1px solid var(--total_row_boldbackground)",
  },
}));

export default useStyles;
